import { ROLE_LABEL } from "@/components/chat/visitorPatterns";

export const ROLE_OPTIONS = [
    { value: "all",   label: "All visitors" },
    { value: "named", label: "Named only" },
    ...Object.entries(ROLE_LABEL).map(([value, label]) => ({ value, label })),
];

const ROLE_PILL_COLORS = {
    caseworker:        "bg-[#0E2A47]/10 text-[#0E2A47]",
    social_worker:     "bg-[#0E2A47]/10 text-[#0E2A47]",
    juvenile_justice:  "bg-[#0E2A47]/10 text-[#0E2A47]",
    foster_parent:     "bg-[#C8A24A]/15 text-[#8a6b1f]",
    parent:            "bg-[#C8A24A]/15 text-[#8a6b1f]",
    guardian:          "bg-[#C8A24A]/15 text-[#8a6b1f]",
    counselor:         "bg-[#7BA37F]/15 text-[#3d6442]",
    school_staff:      "bg-[#7BA37F]/15 text-[#3d6442]",
    faith_leader:      "bg-[#7BA37F]/15 text-[#3d6442]",
    self:              "bg-[#EFEBE0] text-[#6F6B63]",
};

export const fmtAgo = (iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    const mins = Math.floor((Date.now() - d.getTime()) / 60000);
    if (mins < 1) return "just now";
    if (mins < 60) return `${mins} min ago`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `${hrs} hr ago`;
    const days = Math.floor(hrs / 24);
    if (days < 30) return `${days} day${days === 1 ? "" : "s"} ago`;
    return d.toLocaleDateString();
};

export function RolePill({ role }) {
    if (!role) {
        return (
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-[#EFEBE0] text-[#6F6B63] text-[11px] font-medium">
                anonymous
            </span>
        );
    }
    const classes = ROLE_PILL_COLORS[role] || "bg-[#EFEBE0] text-[#6F6B63]";
    return (
        <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium ${classes}`}>
            {ROLE_LABEL[role] || role}
        </span>
    );
}
